let isLocationChangeEventInstalled = false;

const dispatchLocationChangeEvent = () => {
  window.dispatchEvent(new Event('locationchange'));
};

/**
 * Installs a global `locationchange` event for apps using the History API.
 * This is useful because `pushState` / `replaceState` do not emit `popstate`.
 */
export const ensureLocationChangeEventInstalled = () => {
  if (isLocationChangeEventInstalled) {
    return;
  }

  if (typeof window === 'undefined' || typeof window.history === 'undefined') {
    return;
  }

  isLocationChangeEventInstalled = true;

  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = ((...args: Parameters<History['pushState']>) => {
    const result = originalPushState(...args);
    dispatchLocationChangeEvent();
    return result;
  }) as History['pushState'];

  window.history.replaceState = ((...args: Parameters<History['replaceState']>) => {
    const result = originalReplaceState(...args);
    dispatchLocationChangeEvent();
    return result;
  }) as History['replaceState'];

  window.addEventListener('popstate', dispatchLocationChangeEvent);
};
